export const SET_UNREAD_COUNT_NOTIFICATIONS = 'setUnreadCountNotifications';
export const SET_NOTIFICATION_LIST = 'setNotificationList';
export const ADD_NEW_NOTIFICATION = 'addNewNotification';
export const SET_DISTURB = 'setDisturb';
